import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IRoutePricesSlideData from '@app/types/data/slides/IRoutePricesSlideData';
import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import { Entry } from 'contentful';
import IConnection from '@app/types/data/base/IConnection';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';

/**
 * Transform for 014-RoutePricesSlide
 */
export default class RoutePricesSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'RoutePricesSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<IRoutePricesSlideData> {
		const data: IRoutePricesSlideData = {
			...(await super.transform(slide, presentationSettings)),
			list: slide.fields.connections.map((item: Entry<any>): IConnection => this.parseConnection(item))
		};

		return data;
	}
}
